<template>
  <div class="error-page">
    <div class="error-code">4<span>0</span>4</div>
    <div class="error-desc">啊哦~ 你所访问的页面不存在</div>
    <div class="error-handle">
      <el-button class="error-btn" type="primary" size="large" @click="goBack"
        >返回上一页</el-button
      >
    </div>
  </div>
</template>

<script>
// let _apiId = '100096';
// let _accessKeyID = '8ae45544-392c-4e43-be48-2dff825fb938';
// let _accessKeySecret = 'b9bfa3ab-d5a8-4c26-9566-c9e59fb5bd0d';
// let _appKey = 'b759efd8faa7d7ebacfdf3e412767458';
// let _appSecret = '835898768744b3c96a6269ea3e11eca0';
// let _timestamp = Math.round(new Date().getTime()/1000).toString();
// this.getRequest('/yunpingtai/itembank/ques/quesList',
//   { stageSubject:'1215',knowledge:'11101108,13',page:1,pageSize:10},
//   {
//     callerReferer: "http://ti.canpoint.cn/",
//     apiId: _apiId,
//     accessKeyID: _accessKeyID ,
//     appKey:_appKey,
//     timestamp:_timestamp,
//     signature:md5(_apiId+_accessKeyID+_accessKeySecret+_appKey+_appSecret+_timestamp)
//   }).then(result => {
//     this.nianJiData = result.data;
// });
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #2d8cf0;
}
.error-code span {
  color: #00a854;
}
.error-desc {
  font-size: 30px;
  color: #777;
}
.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}
.error-btn {
  /* margin-left: 100px; */
}
</style>
